import React from "react";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Home from "./pages/Home";
import Cookies from "./pages/Documents/Cookies";
import General from "./pages/Documents/General";
import General_v2 from "./pages/Documents/General_v2";
import ImageUse from "./pages/Documents/ImageUse";
import International from "./pages/Documents/International";
import Payment from "./pages/Documents/Payment";
import Prime from "./pages/Documents/Prime";
import Privacy from "./pages/Documents/Privacy";
import Privacy_v2 from "./pages/Documents/Privacy_v2";
import Regulation from "./pages/Documents/Regulation";
import { GlobalStyle } from "./components/Styled";
import General_v3 from "./pages/Documents/General_v3";
import General_v4 from "./pages/Documents/General_v4";
import General_v5 from "./pages/Documents/General_v5";
import General_v6 from "./pages/Documents/General_v6";
import AIJourney_v1 from "./pages/Documents/AIJourney_v1";
import AIJourney_v2 from "./pages/Documents/AIJourney_v2";
import AIJourney_v3 from "./pages/Documents/AIJourney_v3";
import AIJourney_v1_Visual from "./pages/Documents/AIJourney_v1_Visual";
import Security from "./pages/Documents/Security";
import Ethics from "./pages/Documents/Ethics";
import TermoCienciaNRF from "./pages/Documents/TermoCienciaNRF";
import TermoCienciaChina from "./pages/Documents/TermoCienciaChina";

function App() {
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#0080ED",
      },
      secondary: {
        main: "#EF6E67",
      },
      success: {
        main: "#2DB5B2",
        dark: "#1E706E",
        light: "#E3FCFC",
      },
    },
    typography: {
      fontFamily: "IBM Plex Sans, Barlow",
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter basename="/docs/">
        <GlobalStyle />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/politica-de-cookies" component={Cookies} />
          <Route path="/termo-de-cobranca-de-encargos-por-atraso" component={Payment} />
          <Route path="/politicas-gerais-de-cancelamento-e-remarcacao" component={General} />
          <Route path="/politicas-gerais-de-cancelamento-e-remarcacao-v2" component={General_v2} />
          <Route path="/politicas-gerais-de-cancelamento-e-remarcacao-v3" component={General_v3} />
          <Route path="/politicas-gerais-de-cancelamento-e-remarcacao-v4" component={General_v4} />
          <Route path="/politicas-gerais-de-cancelamento-e-remarcacao-v5" component={General_v5} />
          <Route path="/politicas-gerais-de-cancelamento-e-remarcacao-v6" component={General_v6} />
          <Route path="/termos-ai-journey-2026" component={AIJourney_v1} />
          <Route path="/termos-ai-journey-2026-v2" component={AIJourney_v2} />
          <Route path="/termos-ai-journey-2026-v3" component={AIJourney_v3} />
          <Route path="/termos-ai-journey-2026-visual" component={AIJourney_v1_Visual} />
          <Route path="/politica-de-seguranca-da-informacao" component={Security} />
          <Route path="/termo-de-ciencia-entrega-nrf-nyc" component={TermoCienciaNRF} />
          <Route path="/termo-de-ciencia-entrega-china-experience" component={TermoCienciaChina} />
          <Route path="/termo-de-autorizacao-de-uso-de-imagem-e-voz" component={ImageUse} />
          <Route
            path="/politica-de-matricula-cancelamento-e-reembolso-imersoes-internacionais"
            component={International}
          />
          <Route path="/politicas-gerais-de-cancelamento-startse-prime" component={Prime} />
          <Route path="/politica-do-regulamento" component={Regulation} />
          <Route path="/politica-de-privacidade" component={Privacy} />
          <Route path="/politica-de-privacidade-2" component={Privacy_v2} />
          <Route path="/codigo-de-conduta-e-etica" component={Ethics} />
        </Switch>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
